import React from 'react';
import Container from 'react-bootstrap/Container';
import Listaparceiros from '../components/Partners/listaparceiros';

const Pagparceiros = () => (
   <>
      <div className="py-5 bg-title">
         <Container>
            <h3>Parceiros</h3> <hr />
         </Container>
      </div>
      <Container>
         <Listaparceiros />
      </Container>
   </>
);

export default Pagparceiros;